import type { ItemReference, IssueItem } from '../types/daily'

type DiscussableItem = IssueItem | ItemReference

export const buildDiscussionText = (item: DiscussableItem) => [
  '我想讨论下面这篇 Daily Read 条目：',
  '',
  `标题：${item.title}`,
  `来源：${item.source.name}`,
  `原文：${item.source.url}`,
  '',
  `摘要：${item.summary}`,
  '',
  `讨论问题：${item.discussion.prompt}`,
  `背景：${item.discussion.context}`,
  '',
  '请先区分已确认事实、来源观点、推断和仍不确定的信息，再和我讨论。',
].join('\n')

export type ShareDiscussionResult =
  | { status: 'shared' | 'copied' | 'cancelled' }
  | { status: 'manual'; value: string }

export async function shareDiscussion(item: DiscussableItem): Promise<ShareDiscussionResult> {
  const value = buildDiscussionText(item)
  if (navigator.share) {
    try {
      await navigator.share({ title: `Daily Read：${item.title}`, text: value })
      return { status: 'shared' }
    } catch (error) {
      if (typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError') return { status: 'cancelled' }
    }
  }
  try {
    if (!navigator.clipboard) throw new Error('Clipboard API unavailable')
    await navigator.clipboard.writeText(value)
    return { status: 'copied' }
  } catch {
    return { status: 'manual', value }
  }
}
